import { Play, Square, Trash2, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Props {
  status: string | undefined;
  isStopping?: boolean;
  isTriggering?: boolean;
  onRunNow: () => void;
  onStopRequested: () => void;
  onDelete: () => void;
}

const ACTIVE_STATUSES = new Set(['pending', 'running']);

export function ConnectorActionButtons({ status, isStopping, isTriggering, onRunNow, onStopRequested, onDelete }: Props) {
  const active = ACTIVE_STATUSES.has(status ?? '');
  // While a Run Now is starting (mutation in flight / optimistic) but the
  // execution has not yet surfaced as pending/running, hard-block a second
  // click: render a disabled "Starting…" button instead of a clickable Run Now.
  const starting = !!isTriggering && !active;

  return (
    <div className="flex items-center gap-2">
      <Button variant="outline" size="sm" onClick={onDelete} disabled={active || starting}>
        <Trash2 className="h-4 w-4 mr-2" aria-hidden />
        Delete
      </Button>

      {starting ? (
        <Button variant="default" size="sm" disabled aria-label="Starting run">
          <Loader2 className="h-4 w-4 mr-2 animate-spin" aria-hidden />
          Starting…
        </Button>
      ) : active ? (
        <Button variant="outline" size="sm" onClick={onStopRequested} disabled={isStopping}
                aria-label={isStopping ? 'Stopping run' : 'Stop run'}>
          {isStopping ? (
            <><Loader2 className="h-4 w-4 mr-2 animate-spin" aria-hidden />Stopping…</>
          ) : (
            <><Square className="h-4 w-4 mr-2" aria-hidden />Stop</>
          )}
        </Button>
      ) : (
        <Button variant="default" size="sm" onClick={onRunNow}>
          <Play className="h-4 w-4 mr-2" aria-hidden />
          Run Now
        </Button>
      )}
    </div>
  );
}
